export const formatValueForSelectables = (idcommand, value, type) => {
  const formattedArray =
    type !== "ComboBox"
      ? idcommand.split(",").map((idcmd, index) => {
          const splittedValues = value.split(",");
          return {
            ItemValue: Number(idcmd),
            ItemContent: splittedValues[index],
          };
        })
      : [
          {
            label: value,
            id: Number(idcommand),
          },
        ];
  return formattedArray;
};
